<template>
	<div class="d-flex align-center">
		<v-btn color="primary" @click="showDlg = true">
			<slot>分类</slot>
		</v-btn>
		<template v-if="showSelection && selectedObjs.length">
			<v-chip
				v-for="item in selectedObjs"
				:key="item.id"
				size="small"
				color="primary"
				variant="tonal"
				class="ml-2"
				closable
				@click:close="unSelectObj(item)"
			>
				{{ item.name }}
			</v-chip>
		</template>

		<v-dialog v-model="showDlg" id="list" max-width="400">
			<v-card>
				<v-card-title>
					<div class="alert alert-primary" role="alert">
						已选：
						<template v-for="item in selectedObjs" class="col-6">
							<span class="badge badge-primary">{{ item.name }}({{ item.id }})</span>
							<v-btn color="error" small outlined @click="unSelectObj(item)">
								<v-icon>$delete</v-icon>
							</v-btn>
						</template>
					</div>
				</v-card-title>
				<v-card-text>
					<template v-if="curPath" v-for="p in curPath">
						/
						<v-btn text @click="getObj(p.id)">{{ p.name }}</v-btn>
					</template>
					<v-treeview
						v-model="selectedObjs"
						item-key="id"
						:value="boundValue"
						activatable
						hoverable
						dense
						:selectable="multiple"
						:items="curTree"
						:selection-type="selectionType"
						return-object
						expand-icon="$expand"
						collapse-icon="$collapse"
						open-on-click
					>
						>

						<!-- <template v-slot:prepend="{ item, open }">
                            <v-icon>
                                {{ open ? '$expand' : '$collapse' }}
                            </v-icon>
                        </template> -->
						<template v-slot:append="{ item, open }">
							<v-btn @click="selectObj(item)">选择</v-btn>
						</template>
					</v-treeview>
				</v-card-text>
				<v-card-actions v-if="multiple">
					<v-btn color="primary" @click="confirm" class="btn btn-sm btn-warning">确定</v-btn>
					<v-btn @click="cancel">取消</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
export default {
	props: {
		// Vue 3 v-model
		modelValue: { type: [Number, String, Array], default: null }, //id
		// 兼容旧调用 :value
		value: { type: [Number, String, Array], default: null }, //id
		root: { type: [Number, String], default: null }, //PRODUCT SHOPPRODUCT MATERIAL
		multiple: { type: Boolean, default: false },
		showSelection: { type: Boolean, default: false }
	},
	emits: ['update:modelValue', 'update:value', 'selected'],
	data() {
		return {
			selected: {},
			selectedObj: null,
			selectedObjs: [], //如果是多选

			curId: null,
			cur: null, //当前分类
			curPath: [],
			curChildren: [],
			showDlg: false,
			curTree: [] //最多3层
		}
	},
	computed: {
		selectionType() {
			return this.multiple ? 'leaf' : 'independent'
		},
		selectedIds() {
			return this.selectedObjs.map((e) => e.id)
		},
		boundValue() {
			return this.modelValue ?? this.value
		},
		boundIds() {
			if (this.boundValue == null || this.boundValue === '') return []
			return (Array.isArray(this.boundValue) ? this.boundValue : [this.boundValue])
				.map((id) => (id != null && typeof id === 'object' ? id.id : id))
				.filter((id) => id != null && id !== '')
		}
	},
	watch: {
		// 编辑时表单数据异步/切换回显：不能只在 mounted 读一次
		boundIds: {
			immediate: true,
			handler(ids) {
				this.syncSelected(ids)
			}
		},
		showDlg(open) {
			if (open) this.getObj(this.root || '')
		}
	},
	mounted() {
		if (this.root) {
			this.getObj(this.root)
		} else this.getObj('')
	},
	methods: {
		syncSelected(ids) {
			const wanted = (ids || []).map((id) => String(id)).sort().join(',')
			const current = this.selectedIds.map((id) => String(id)).sort().join(',')
			if (wanted === current) return
			if (!ids || !ids.length) {
				this.selectedObjs = []
				return
			}
			if (this.multiple || ids.length > 1) {
				this.getObjs(ids)
				return
			}
			this.$api.category.getById(ids[0], (r) => {
				const obj = Array.isArray(r) ? r[0] : r
				// 请求返回时外部值可能已变更，丢弃过期结果
				if (!obj || String(this.boundIds[0]) !== String(ids[0])) return
				this.selectedObjs = [{ ...obj, id: obj.id ?? ids[0] }]
			})
		},
		emitSelection() {
			const payload = this.multiple ? [...this.selectedIds] : this.selectedIds[0] ?? null
			this.$emit('update:modelValue', payload)
			this.$emit('update:value', payload)
			this.$emit('selected', this.selectedIds, this.selectedObjs)
		},
		cancel() {
			this.showDlg = false
		},
		showObjs() {
			this.getObj(this.root)
			this.showDlg = true
		},
		getObjs(catids) {
			if (catids.length == 0) return
			this.$api.category.getByIds(catids.join(',') + '/tupple', (r) => {
				const list = Array.isArray(r) ? r : r ? [r] : []
				const wanted = catids.map((id) => String(id)).sort().join(',')
				if (wanted !== this.boundIds.map((id) => String(id)).sort().join(',')) return
				this.selectedObjs = list
			})
		},
		getObj(catid) {
			return new Promise((resolve, reject) => {
				this.$api.category.getTree(
					catid,
					(response) => {
						this.curTree = [response.tree]
						this.cur = response.category
						this.curPath = response.path
						resolve(response)
					},
					(error) => {
						reject(error)
						console.log('gettree', error)
					}
				)
			})
		},
		selectObj(obj) {
			if (!obj || obj.id == null) return
			let eindex = this.selectedObjs.findIndex((e) => parseInt(e.id) === parseInt(obj.id))
			if (eindex < 0) {
				if (!this.multiple) {
					this.selectedObjs = []
				}
				this.selectedObjs.push(obj)
			}
			if (!this.multiple) {
				this.showDlg = false
				this.emitSelection()
			}
		},
		unSelectObj(obj) {
			if (this.multiple) {
				var idx = this.selectedObjs.findIndex((e) => e.id === obj.id)
				if (idx >= 0) {
					this.selectedObjs.splice(idx, 1)
				}
				this.emitSelection()
			} else {
				this.selectedObjs = []
				this.emitSelection()
				this.showDlg = false
			}
		},
		confirm() {
			this.emitSelection()
			this.showDlg = false
		},
		clearAll() {
			this.selectedObjs = []
		}
	}
}
</script>
